import {connect} from 'react-redux';
import {DeliveryManagerContainer} from './DeliveryManagerContainer';
import {
    setDeliveryJobs,
    resetDeliveryJobs,
    retryTask,
    cancelTask,
    getDeliverySummaryAction,
} from './Redux/DeliveryManagerAction';
import {DeliveryManagerState} from './DeliveryManagerTypes';

export type DeliveryState = {deliveryManager: DeliveryManagerState};

export const mapState = (state: any): DeliveryState => {
    const {deliveryManager} = state;

    return {
        deliveryManager,
    };
};

export const mapDispatch = {
    setQCJobs: setDeliveryJobs,
    resetQCJobs: resetDeliveryJobs,
    getQCJobsSummary: getDeliverySummaryAction,
    retryTask,
    cancelTask,
};

export default connect(mapState, mapDispatch)(DeliveryManagerContainer);
